import React from 'react';
import ReactDOM from 'react-dom';
import PickerTemplate from '../../components/builder/PickerTemplate.js';
import _ from 'lodash';
import OptionColumn from '../../components/general/OptionColumn.js';

export default class Step3 extends React.Component {
	constructor(props) {
		super(props);
		this.findCategory = this.findCategory.bind(this);
		this.findTemplates = this.findTemplates.bind(this);
	}

	findCategory() {
		return _.find(this.props.categories, {'id':this.props.selectedStep1});
	}

	findTemplates() {
		const category = this.findCategory();

		return !category ? []:category.templates;
	}

	componentWillMount() {
		if(this.props.categories.length == 0 || this.props.selectedStep1 === false) {
			this.props.restart();
		}
	}

	render() {	
		if(this.props.categories.length == 0) {
			return null;
		}
		return (
			<OptionColumn title="Template" description={`Select a template for this ${(this.props.router.params.type == 'email' ? 'email':'popup')}`}>
				<ul className="list-group list-group-full">
				{this.findTemplates().map((c) => {
            		return <PickerTemplate 
            			key={c.id}
                		item={c.id}
						template={c}
						type={this.props.router.params.type}
                		onSelect={this.props.onSelect}
                	/>
    			})}
            	</ul>
			</OptionColumn>
		);
	}
}




// WEBPACK FOOTER //
// ./containers/picker/step3.js